// value НЕ ИЗМЕНЯТЬ!
module.exports = {
  USER_ROLES: {
    USER: 'user',
    WORKER: 'worker',
    EMPLOYER: 'employer',
    SUPERVISOR: 'supervisor',
    RECRUITER: 'recruiter',
    PARTNER: 'partner',
  },
  OPERATOR_ROLES: [
    { caption: 'COORDINATOR', value: 'coordinator' },
    { caption: 'RECRUITER', value: 'recruiter' },
    { caption: 'CUSTOMER_SERVICE', value: 'customer_service' },
    { caption: 'MANAGER', value: 'manager' },
    { caption: 'ADMIN', value: 'admin' },
    { caption: 'SUPER_ADMIN', value: 'super_admin' },
    { caption: 'OPERATOR', value: 'operator' },
    { caption: 'USER', value: 'user' },
    { caption: 'PAYMENT_MODERATION_ADMIN', value: 'payment_moderation_admin' },
    {
      caption: 'PAYMENT_MODERATION_MONTHLY_SALARY',
      value: 'payment_moderation_monthly_salary',
    },
    { caption: 'PAYMENT_MODERATION_BONUS', value: 'payment_moderation_bonus' },
  ],
};
